import { Pipe, PipeTransform } from '@angular/core'
import { BuildingType } from '@wm-front/client/graphql'

@Pipe({
  name: 'buildingType',
  standalone: true,
})
export class BuildingTypePipe implements PipeTransform {
  /** Transform building type into localised string
   * @param { BuildingType } value
   * @param { boolean } isMinify
   * @returns { string }
   */
  public transform(value: BuildingType, isMinify: boolean): string {
    switch (value) {
      case BuildingType.Commercial:
        return isMinify
          ? $localize`:Label | Value for the building type commercial minified@@BuildingTypeCommercialMinifiedLabel:(T)`
          : $localize`:Label | Value for the building type commercial@@BuildingTypeCommercialLabel:Tertiaire`
      case BuildingType.GovernmentFacility:
        return isMinify
          ? $localize`:Label | Value for the building type government facility minified@@BuildingTypeGovernmentFacilityMinifiedLabel:---`
          : $localize`:Label | Value for the building type government facility@@BuildingTypeGovernmentFacilityLabel:---`
      case BuildingType.Residential:
        return isMinify
          ? $localize`:Label | Value for the building type residential minified@@BuildingTypeResidentialMinifiedLabel:(R)`
          : $localize`:Label | Value for the building type residential@@BuildingTypeResidentialLabel:Résidentiel`
      default:
        return $localize`:Label | Value for the building type unvailable@@BuildingTypeUnvailableLabel:Indisponible`
    }
  }
}
